/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION, VALIDATION_MESSAGES } from '../../utils/translation-constants'

export const ChangePasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    // .matches(
    //   /^(?=.{8,14}$)(?=..*?[A-Za-z])(?=.*?\d)(?=.*?\W).*$/,
    //   'New Password do not match the password criteria',
    // )
    .required(i18n.t(VALIDATION.NEWPASSWORD))
    .min(8, 'Password minimum Length should be 8 characters')
    .max(14, 'Password maximum Length should be 14 characters'),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], i18n.t(VALIDATION.PASSWORDNOTMATCH))
    .required(i18n.t(VALIDATION.CONFIRMNEWPASSWORD)),
  oldPassword: Yup.string().required('Old Password is required'),
})

export const AddAccountNameSchema = Yup.object().shape({
  nickName: Yup.string()
    .required(i18n.t(VALIDATION_MESSAGES.SHORT_NAME))
    .min(2, i18n.t(VALIDATION_MESSAGES.SHORT_NAME_VALID))
    .max(20, i18n.t(VALIDATION_MESSAGES.SHORT_NAME_VALID)),
  // .matches(new RegExp('[a-zA-Z]$'), 'Please enter Short Name'),
  accountNumber: Yup.string().required(i18n.t(VALIDATION.ACCOUNTNO)),
})
